import DevTools from 'mobx-react-devtools';
import * as React from 'react';
import { IndexHtmlConfig, SelectTemplateFolder } from 'ws-voice-infinity-global-module/lib/components';
import MainRouter from './routers/mainRouter';

export const AppConfig = () => {
    return (
        <>
            <IndexHtmlConfig />
            {process.env.NODE_ENV === 'development' && <DevTools />}
            {
                process.env.NODE_ENV === 'development' &&
                <SelectTemplateFolder
                    position="bottom-left"
                />
            }
            <MainRouter />
        </>
    );
};
